export default __webpack_public_path__ + "static/media/user_icon.ca44e59b.png";